import { render, staticRenderFns } from "./TheSpecialEventSection.vue?vue&type=template&id=df2c6246&name=the-special-event-section&"
import script from "./TheSpecialEventSection.vue?vue&type=script&lang=js&"
export * from "./TheSpecialEventSection.vue?vue&type=script&lang=js&"
import style0 from "./TheSpecialEventSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports